import styled from 'styled-components';
import { GetColor, GetTypography } from 'venn-ui-kit';
import './font.css';

export default styled.div`
  font-family: ${GetTypography.fontFamily};
  color: ${GetColor.Black};
  box-sizing: border-box;

  p {
    font-size: 14px;
  }

  a {
    cursor: pointer;
    color: ${GetColor.Primary.Dark};
    text-decoration: none;
    transition: color 0.15s linear;
  }

  button,
  textarea,
  input {
    font-family: ${GetTypography.fontFamily};
  }

  button {
    cursor: pointer;
  }

  :focus {
    outline-color: ${GetColor.Primary.Main};
    outline-offset: -4px;
  }
`;
